export const SECOND_AUTH_NONE = 'NONE';
export const SECOND_AUTH_SMS = 'SMS';
export const SECOND_AUTH_SMS_CARD = 'SMSUKEY';
export const SECOND_AUTH_CARD = 'UKEY';

export default {
    [SECOND_AUTH_NONE]: '无',
    [SECOND_AUTH_SMS]: '短信',
    [SECOND_AUTH_SMS_CARD]: '短信+U盾',
    [SECOND_AUTH_CARD]: 'U盾',
};
